import { maybe, Maybe } from '@passionware/monads';

export function resolvePronounsForResourceType(
  optionId: Maybe<number>,
  resourceTypeId: Maybe<number>,
  pronounsById: Map<number, string>,
  pronounsEnabledResourceTypeIds: readonly number[]
): string | null {
  if (maybe.isAbsent(optionId) || maybe.isAbsent(resourceTypeId)) {
    return null;
  }
  if (!pronounsEnabledResourceTypeIds.includes(Number(resourceTypeId))) {
    return null;
  }
  return pronounsById.get(optionId) ?? null;
}
